module.exports = __webpack_public_path__ + "img/greenCircle.6d85be81.png";